import { createContext, useContext, useState, useCallback } from "react";
import translations from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("dslr_lang") || "en"
  );

  const toggleLang = useCallback(() => {
    const next = lang === "en" ? "es" : "en";
    setLang(next);
    localStorage.setItem("dslr_lang", next);
  }, [lang]);

  const t = useCallback(
    (key) => translations[lang]?.[key] || translations["en"]?.[key] || key,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}
